import { FavoritCasinoStateType } from "../../../common/types/Casino/FavoritCasinoStateType";

type setFavoritsLocalType = {
  type: string;
  payload: FavoritCasinoStateType;
};

function setFavoritsLocalSelect(payload: FavoritCasinoStateType): setFavoritsLocalType {
  return {
    type: 'SET_FAVORITS_LOCAL_SELECT',
    payload,
  };
}

export { setFavoritsLocalSelect };
